import React from 'react'
import {BaseButton, Stack, Text} from '../../vanilla'
import {Link} from '../link'
import LoadingOverlay from '../loading-overlay'
import useDeliveryBooking from '../../hooks/use-delivery-booking'
import {useBasketStore, useCustomerStore} from '../../store/hooks/useStore'
import { DeliveryTimeAndDate } from './delivery-time-and-date'

export const ChangeOrBookDelivery = ({postcode = ''}) => {
  const {clearPostalCode, loading} = useDeliveryBooking()
  const {nextAvailableSlot} = useBasketStore()
  const {isRegistered} = useCustomerStore()

  return (
    <Stack
      width={['full', 'auto']}
      flexDirection={['column', 'row']}
      spacing={['16px', '24px']}
      position="relative"
      data-test-selector="book-delivery"
    >
      <LoadingOverlay isLoading={loading} />
      <Stack spacing="0px">
        <Text
          textAlign={['left', 'right']}
          variant="text4"
          color="accent0"
          lineHeight="short"
          data-test-selector="postcode-success"
          data-cs-mask=""
        >
          {isRegistered && nextAvailableSlot
            ? `Next available delivery for ${postcode}`
            : `Great! We'll deliver to ${postcode}`}
        </Text>
        {isRegistered && nextAvailableSlot ? (
          <DeliveryTimeAndDate
            startHour={nextAvailableSlot.startHour}
            endHour={nextAvailableSlot.endHour}
            showDate={true}
            windowStartTime={nextAvailableSlot.windowStartTime}
            windowEndTime={nextAvailableSlot.windowEndTime}
            textProps={{variant: 'text4', lineHeight: 'short', textAlign: ['left', 'right']}}
          />
        ) : (
          <>
            <Text textAlign={['left', 'right']} variant="text4" lineHeight="short">
              Postcode not right?{' '}
              <Text
                as="span"
                variant="text4"
                padding="0px"
                textDecoration="underline"
                color="accent5"
                lineHeight="short"
                data-test-selector="change-postcode"
                cursor="pointer"
                onClick={clearPostalCode}
              >
                Change it
              </Text>
            </Text>
          </>
        )}
      </Stack>
      <BaseButton
        as={Link}
        href="/book-delivery"
        data-test-selector="book-delivery-button"
        variant="primary"
        size="sm"
        width={['full', 'auto']}
      >
        <Text variant="unstyled" fontSize="inherit" lineHeight="inherit">
          Book Delivery
        </Text>
      </BaseButton>
    </Stack>
  )
}
